import {Injectable} from '@angular/core';
import {SecureTable} from '../secure.table';
import {WmWoundAnswer} from '../../interfaces/wound-management/wm-wound-answer';
import {DefaultAdapter} from '../../adapters/default.adapter';
import {WmWoundAnswerFactory} from '../../factories/wound-management/wm-wound-answer-factory';
import {db} from '../db.service';


@Injectable({
  providedIn: 'root'
})
export class WmWoundAnswersTable extends SecureTable<WmWoundAnswer> {

  constructor() {
    super(db.wmWoundAnswers);
    this._tableSyncSettings = {
      error: false,
      syncMode: 'all',
      dependencies: [],
      // @ts-ignore
      adapter: new DefaultAdapter<WmWoundAnswer>({
        api: ['wound-management', 'wound-documentation-entries', '{foreignKey}', 'wound-answers'],
        foreignKey: 'wmWoundDocumentationEntryUuid',
        fromArray: WmWoundAnswerFactory.fromArray,
        toArray: WmWoundAnswerFactory.toArray
      })
    };
  }

  /**
   *
   * @param wmWoundDocumentationEntryUuid
   */
  public getByWmWoundDocumentationEntryUuid(wmWoundDocumentationEntryUuid: string): Promise<WmWoundAnswer[]> {
    return this.table.where('wmWoundDocumentationEntryUuid').equals(wmWoundDocumentationEntryUuid).toArray();
  }

  /**
   *
   * @param wmWoundDocumentationEntryUuids
   */
  public getByWmWoundDocumentationEntryUuids(wmWoundDocumentationEntryUuids: string[]): Promise<WmWoundAnswer[]> {
    return this.table.where('wmWoundDocumentationEntryUuid').anyOf(wmWoundDocumentationEntryUuids).toArray();
  }

  /**
   *
   * @param wmWoundDocumentationEntryUuid
   */
  public async removeByWmWoundDocumentationEntryUuid(wmWoundDocumentationEntryUuid: string): Promise<void> {
    const wmWoundAnswers =
      await this.table.where('wmWoundDocumentationEntryUuid').equals(wmWoundDocumentationEntryUuid).toArray();
    await this.removeMany(wmWoundAnswers.map((wmWoundAnswer) => wmWoundAnswer.uuid), true);
  }

}
